module.exports = __webpack_public_path__ + "static/media/1.3de39318.jpg";